import { render, staticRenderFns } from "./RestrictedEmailDomainModify.vue?vue&type=template&id=b0083e8c"
import script from "@/scripts/modal/systemManager/restrictedEmailDomain/restrictedEmailDomainModify.js?vue&type=script&lang=js&external"
export * from "@/scripts/modal/systemManager/restrictedEmailDomain/restrictedEmailDomainModify.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports